<div class="mobile-scrollable-content" [style.height.px]="layout.dimensions().contentHeight">
	<ng-content></ng-content>
</div>